import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgTextBlock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "nonzero",
		d: "M11.667 14.167H3.333v1.666h8.334v-1.666zm5-6.667H3.333v1.667h13.334V7.5zm-13.334 5h13.334v-1.667H3.333V12.5zm0-8.333v1.666h13.334V4.167H3.333z"
	})
});
export default SvgTextBlock;
